import { useIntl } from '@jetshop/intl'

// Display config for the Vectory stockStatus facet values, in the order they are shown
export const useStockStatusOptions = () => {
   const t = useIntl()
   return [
      {
         value: 'web',
         label: t('In stock online'),
         subtitle: t('Ships within 1-3 business days'),
         color: 'var(--color-instock)',
      },
      {
         value: 'store',
         label: t('In stock in Borås'),
         subtitle: t('Pick up in store today'),
         color: 'var(--color-instock)',
      },
      {
         value: 'order',
         label: t('Order item'),
         subtitle: t('Delivery within 1-3 weeks'),
         color: '#e0a030',
      },
   ]
}

export const getStockStatusLabel = (options = [], value) =>
   options.find(option => option.value === value)?.label ?? value

/**
 * Merges stockStatus facets into the display config. Vectory leaves out values without hits,
 * so those are hidden unless they are currently selected.
 */
export const getStockStatusFilterOptions = (
   options = [],
   facets = [],
   selectedValues = []
) =>
   options
      .map(option => ({
         ...option,
         count:
            facets?.find(facet => facet?.value === option.value)?.count ?? 0,
      }))
      .filter(
         option => option.count > 0 || selectedValues.includes(option.value)
      )
